import type {z} from "zod";

import {CreateMaterialFunctionBody} from "@project/sdk/engineering/zod";

export const createMaterialFunctionFormSchema = CreateMaterialFunctionBody;
export type CreateMaterialFunctionFormPayload = z.output<typeof createMaterialFunctionFormSchema>;

export const draftCreateMaterialFunctionFormSchema = createMaterialFunctionFormSchema.partial();
export type DraftCreateMaterialFunctionFormPayload = z.output<
  typeof draftCreateMaterialFunctionFormSchema
>;
